import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PartHeaderComponent } from '../parts/part-header/part-header.component';

@Component({
    selector: 'app-manufacturer',
    imports: [
        PartHeaderComponent
    ],
    templateUrl: './manufacturer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './manufacturer.component.scss'
})
export class ManufacturerComponent {

}
